module.exports = __webpack_public_path__ + "static/media/23.7d03024c.jpg";